<template>
  <edit-location />
</template>

<script>
import EditLocation from "@/components/3pl/Settings/LocationAndTax/Location/EditLocation";
export default {
  components: {
    EditLocation,
  },
};
</script>

<style></style>
